/*
 * @Description : 重构basicService服务类
 * @Author      : pishengjun
 * @Date        : 2024-12-19 11:41:45
 */

import axios from "@/utils/request";
import { RequestEnum, ServiceGateWay } from "@/utils/enum";
import { assignWith } from "lodash";
import type { SystemSetting, TenantSetting, WebSystemSetting } from "../interfaceModel/basicService";
import { Base64 } from "js-base64";
import { store } from "@/store";

export class BasicServiceClass {
  static serve = ServiceGateWay.BASIC_SERVICE;
  // 获取设置
  static async getSystemSetting(): Promise<WebSystemSetting> {
    // 获取平台的系统设置
    const systemSetting = await axios<SystemSetting>({ url: `${this.serve}/ExamineeSystemSettingService/SystemSetting`, method: RequestEnum.GET, options: { token: "" } });
    // 获取网站的系统设置
    const httpUrl = Base64.encode(window.location.origin);
    const tenantSetting = await axios<TenantSetting>({ url: `${this.serve}/ExamineeTenantAccessService/ByHttpAddress/${httpUrl}`, method: RequestEnum.GET, options: { token: "" } });
    const webSystemSetting: WebSystemSetting = assignWith({}, systemSetting, tenantSetting, (s, o) => o ?? s);
    store.commit("SET_DATA", { name: "webSystemSetting", data: webSystemSetting });
    return webSystemSetting;
  }
}
